import Service from '@/services/modules/proposals.service';

const add = async({ commit }, _object) => {
    const response = Service.add(_object);

    response.then(function (_response) {
        commit('add', _response);
    });

    return response;
};

const all = async ({ commit }, _itens) => {
    const response = Service.all(_itens.limit, _itens.currentPage, _itens.params);

    response.then(function (_response) {
        if (_response.data !== undefined) {
            commit('setList', _response.data);
        } else {
            commit('setList', _response);
        }
    });

    return response;
};

const deadline = async({commit}, _itens) => {
    const response = Service.all(_itens.limit, _itens.currentPage, _itens.params);

    return response;
};

const edit = async({ commit }, _obj) => {
    const response = Service.edit(_obj.id, _obj);

    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};

const get = async ({ commit }, _id) => {
    const response = Service.get(_id);
    response.then(function (_response) {
        commit('setObject', _response);
    });

    return response;
};

const print = async ({ commit }, _id) => {
    const response = Service.print(_id);
    response.then(function (_response) {
        commit('setPrintable', _response);
    });

    return response;
};

const pay_installment = async({ commit }, _proposalPayment) => {
    const response = Service.payInstallment(_proposalPayment.id, {installment_id: _proposalPayment.installment_id, payments: _proposalPayment.payments});

    response.then(function (_response) {
        commit('payInstallment', _response);
    });

    return response;
};

const reverse_pay_installment = async({ commit }, _proposalPayment) => {
    const response = Service.reversePayInstallment(_proposalPayment.id, {installment_id: _proposalPayment.installment_id, reversal_at: _proposalPayment.reversal_at});

    response.then(function (_response) {
        commit('payInstallment', _response);
    });

    return response;
};

const edit_parcel = async({ commit }, _proposalPayment) => {
    const response = Service.editInstallment(_proposalPayment.id, {installment_id: _proposalPayment.installment_id, due_at: _proposalPayment.due_at, change_all_installments: _proposalPayment.change_all_installments, price : _proposalPayment.price});

    response.then(function (_response) {
        commit('setObjectInstallments', _response);
    });

    return response;
};

const rem = async({ commit }, _module) => {
    const response = Service.rem(_module.id);

    return response;
};

const duplicateProposal = ({ commit }, _module) => {
    const response = Service.duplicateProposal(_module);

    return response;
};

const validProtocol = async({ commit }, _object) => {
    const response = Service.validProtocol(_object);

    return response;
};

export default {
    add,
    all,
    deadline,
    edit,
    get,
    print,
    pay_installment,
    reverse_pay_installment,
    edit_parcel,
    rem,
    duplicateProposal,
    validProtocol
};